/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

export const COLOR_TYPE = {
  basicType: [
    {
      text: 'Typography 100',
      color: '--cds-alias-typography-color-100',
    },
    {
      text: 'Typography 200',
      color: '--cds-alias-typography-color-200',
    },
    {
      text: 'Typography 300',
      color: '--cds-alias-typography-color-300',
    },
    {
      text: 'Typography 400',
      color: '--cds-alias-typography-color-400',
    },
    {
      text: 'Typography 450',
      color: '--cds-alias-typography-color-450',
    },
    {
      text: 'Typography 500',
      color: '--cds-alias-typography-color-500',
    },
  ],
  links: [
    {
      text: 'link-on-colorbg',
      color: '--cds-alias-typography-link-on-colorbg',
    },
    {
      text: 'link-color',
      color: '--cds-alias-typography-link-color',
    },
    {
      text: 'link-color-hover',
      color: '--cds-alias-typography-link-color-hover',
    },
    {
      text: 'link-color-visited',
      color: '--cds-alias-typography-link-color-visited',
    },
    {
      text: 'link-color-visited-hover',
      color: '--cds-alias-typography-link-color-visited-hover',
    },
  ],
};
